import React, { useEffect } from "react";
import { Box, Divider } from "@mui/material";
import WorkRequests from "./WorkRequests";
import ProcessWorkRequests from "./ProcessWorkRequests";
import SpecialAnalyses from "../SpecialAnalysis/SpecialAnalysis";
import ProcessSpecialAnalysis from "../SpecialAnalysis/ProcessSpecialAnalysis";
import { GlobalTabCollection, StyledTab } from "../../pages/styles";
import { useAuth } from "../../context/AuthContext";
import { Roles } from "../../constants/roles";
import { useHistory, useParams } from "react-router-dom";
import WorkRequest from "../../api/WorkRequest/WorkRequest";
import SpecialAnalysis from "../../api/SpecialAnalysis/SpecialAnalysis";
import SDSBacklog from "./SDS/Backlog";
import ProcessSDS from "./SDS/ProcessSDS";
import { copyWorkRequest, sanitizeWorkRequestForCreate } from "./NewWorkRequestRedesign/constants";


const MIDASWorkRequests = ({ initialTabValue = 0 }) => {
  const { view, id } = useParams();
  const [tabValue, setTabValue] = React.useState(initialTabValue);

  const history = useHistory();

  const { hasAnyRole } = useAuth();
  const isWorkRequestWorker = hasAnyRole([Roles.WorkRequestWorker, Roles.Developer]);
  const isSpecialAnalysisWorker = hasAnyRole([Roles.SpecialAnalysisWorker, Roles.Developer]);

  if (!isWorkRequestWorker && initialTabValue === 1)
    window.location.href = "/workRequests";

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  async function copyWorkRequestHandler(workRequestId) {
    const result = await WorkRequest.getById(workRequestId);
    if (result) {
      result.typeName = result.typeName === "Fuels Request w/ Shipping" ? "Shipping" : result.typeName

      const payload = sanitizeWorkRequestForCreate(copyWorkRequest(result));
      const res = await WorkRequest.newCreateWorkRequest(payload);

      if (res?.message === "Success" && res.result?.id) {
        history.push(`/newWorkRequestRedesign/${res.result.id}`);
      } else {
        window.alert(`There was an error copying the work request. ${res?.message ?? ""}`);
      }
    }
  }

  async function copySpecialAnalysis(specialAnalysisId) {
    const result = await SpecialAnalysis.getById(specialAnalysisId);
    if (result) {
      history.push({
        pathname: '/newSpecialAnalysis',
        state: { mySpecialAnalysis: result }
      })
    }
  }

  useEffect(() => {
      switch (view) {
        case "backlog": {
          setTabValue(4);
          break;
        }
        case "process": {
          setTabValue(5);
          break;
        }
        default: {
          // ignore
        }
      }
    }, [view]);


  const renderSearchTab = () => {
    switch (tabValue) {
      case 0: {
        return <WorkRequests copyWorkRequest={copyWorkRequestHandler} />;
      }
      case 1: {
        return <ProcessWorkRequests copyWorkRequest={copyWorkRequestHandler} />;
      }
      case 2: {
        return <SpecialAnalyses copySpecialAnalysis={copySpecialAnalysis} />;
      }
      case 3: {
        return <ProcessSpecialAnalysis copySpecialAnalysis={copySpecialAnalysis} />;
      }
      case 4: {
        return <SDSBacklog id={id} />
      }
      case 5: {
        return <ProcessSDS id={id} />;
      }

      // case 2: {
      //   return (
      //     <div>
      //       <span className="pageheader">Work Request Metrics</span>
      //       <Divider className="dividerbar" />
      //       <p>This page is currently under construction</p>
      //     </div>
      //   );
      // }
      default: {
        alert(tabValue);
      }
    }
  };
  return (
    <Box paddingBottom={4}>
      <span className="pageheader">MIDAS Requests</span>
      <Divider className="dividerbar" />
      <div>
        <Box sx={{ bgcolor: "#fff", pt: 3, pb: 1 }}>
          <GlobalTabCollection
            value={tabValue}
            onChange={handleChange}
            aria-label="ant example"
          >
            <StyledTab label="Submit Work Requests" />
            <StyledTab
              disabled={!isWorkRequestWorker}
              label="Process Work Requests"
            />

            <StyledTab label="Submit Special Analysis"/>
            <StyledTab
              disabled={!isSpecialAnalysisWorker}
              label="Process Special Analysis"
            />

            <StyledTab label="Submit SDS Request" />
            <StyledTab label="Process SDS Requests" />

          </GlobalTabCollection>
        </Box>
        {renderSearchTab()}
      </div>
    </Box>
  );
};

export default MIDASWorkRequests;
